import styled from 'styled-components';

export const LogOutButton = styled.button`
  align-self: start;
  color: ${({ theme: { colors } }) => colors.red_1};
  font-size: 1rem;
  cursor: pointer;
`;
